module.exports = __webpack_public_path__ + "img/aboutUsBanner.834eb39f.webp";